import React from "react";
import { X } from "lucide-react";

const Modal = ({ show, onHide, title, children }) => {
  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={onHide}
    >
      <div
        className="bg-white rounded-lg shadow-lg w-[28rem] animate-fadeIn"
        style={{ position: "relative" }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onHide}
          aria-label="Close modal"
          style={{
            position: "absolute",
            top: 12,
            right: 12,
            width: 34,
            height: 34,
            border: "none",
            borderRadius: "50%",
            background: "#f6f1ec",
            color: "#5f5148",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: 2,
          }}
        >
          <X size={18} />
        </button>
        <div className="modal-header">
          <div className="modal-title h4">
            {title}
          </div>
        </div>
        <div className="modal-body">
            {children}
        </div>
        
        
        
      </div>
    </div>
  );
};

export default Modal;
